import AWS from 'aws-sdk'
import {
  AuthenticationDetails,
  CognitoUserPool,
  CognitoUser,
} from 'amazon-cognito-identity-js'
import { useEffect, useState } from 'react'
import jwt_decode from 'jwt-decode'
import dynamoProvider from './dynamo'

const UserPoolId = process.env.REACT_APP_USER_POOL_ID
const ClientId = process.env.REACT_APP_CLIENT_ID
const IdentityPoolId = process.env.REACT_APP_IDENTITY_POOL_ID
const region = process.env.REACT_APP_REGION
const cognitoEndpoint = `cognito-idp.${region}.amazonaws.com/${UserPoolId}`
const userPool = new CognitoUserPool({ UserPoolId, ClientId })
AWS.config.region = region

const cognitoProvider = {
  login: ({ username, password }) => signIn(username, password),
  loginPromise: ({ username, password }) => signInPromise(username, password),
  logout: () => {
    const cognitoUser = userPool.getCurrentUser()
    cognitoUser && cognitoUser.signOut()
    AWS.config.credentials = null
    localStorage.clear()
    return Promise.resolve()
  },
  getPermissions: async () => {
    const cognitoUser = userPool.getCurrentUser()
    if (!cognitoUser) return Promise.reject()

    const decoded = getDecodedToken(cognitoUser)
    const { data } = await dynamoProvider.getOne('users', { id: decoded.sub })
    return Promise.resolve(data ? [data?.type] : [])
  },
  checkAuth: () =>
    AWS.config.credentials ? Promise.resolve() : Promise.reject(),
  checkError: () => Promise.resolve(),
}

export default cognitoProvider

const signIn = (Username, Password) => {
  const details = new AuthenticationDetails({ Username, Password })
  const cognitoUser = new CognitoUser({ Username, Pool: userPool })

  cognitoUser.authenticateUser(details, {
    onSuccess: (result) => {
      setCredentials(result)
      window.location = ''
    },
    onFailure: function (err) {
      alert(err.message || JSON.stringify(err))
    },
  })
}

const signInPromise = (Username, Password) => {
  return new Promise((resolve) => {
    const details = new AuthenticationDetails({ Username, Password })
    const cognitoUser = new CognitoUser({ Username, Pool: userPool })

    cognitoUser.authenticateUser(details, {
      onSuccess: (result) => {
        resolve(result.getIdToken().getJwtToken())
      },
      onFailure: function (err) {
        alert(err.message || JSON.stringify(err))
      },
    })
  })
}

const setCredentials = (result) => {
  const idToken = result.getIdToken().getJwtToken()

  AWS.config.credentials = new AWS.CognitoIdentityCredentials({
    IdentityPoolId,
    Logins: { [cognitoEndpoint]: idToken },
  })

  return idToken
}

export const checkCredentials = () => {
  const cognitoUser = userPool.getCurrentUser()
  if (!cognitoUser) return Promise.resolve()
  return new Promise((resolve) => {
    cognitoUser.getSession((err, session) => {
      if (err || !session.isValid()) {
        return alert(err.message || JSON.stringify(err))
      }

      resolve(setCredentials(session))
    })
  })
}

export const useAuthLoading = () => {
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    checkCredentials().then(() => setLoading(false))
  }, [])
  return loading
}

export const getDecodedToken = (cognitoUser = userPool.getCurrentUser()) => {
  if (!cognitoUser) return null
  let decoded

  try {
    const storageToken = Object.entries(cognitoUser.storage).find(([k]) =>
      k.match(/idToken/),
    )
    decoded = jwt_decode(storageToken[1])
  } catch (e) {
    console.error(e)
  }

  return decoded
}

export const getUserId = (cognitoUser = userPool.getCurrentUser()) => {
  const key = Object.keys(localStorage).find((k) => k.match(/LastAuthUser/))
  const item = localStorage.getItem(key)

  return item
}
